import { Product } from 'lib/enum/product.enum';
import { privateApi, UserProductRole } from 'services';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchUserProductItemRoles = (businessAccountId: string, product: Product): Promise<UserProductRole[]> =>
    privateApi.get<UserProductRole[]>(`business-accounts/${businessAccountId}/products/${product}/user-roles`);

const create = async (userProductRole: any): Promise<UserProductRole> =>
    privateApi.post<UserProductRole>('user-product-roles', userProductRole);

const update = async (userContextRoleEntityId: string, roleId: string): Promise<UserProductRole> =>
    privateApi.put<UserProductRole>(`user-product-roles/${userContextRoleEntityId}`, {
        role: roleId,
    });

const remove = async (userContextRoleEntityId: string): Promise<void> =>
    privateApi.delete(`user-product-roles/${userContextRoleEntityId}`);

export const UserProductRoleGateway = {
    fetchUserProductItemRoles,
    create,
    update,
    remove,
};

const cancelableFetchUserProductItemRoles = (businessAccountId: string, product: Product): Promise<UserProductRole[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<UserProductRole[]>(
        `business-accounts/${businessAccountId}/products/${product}/user-roles`,
    );

export const CancelableUserProductRoleGateway = {
    cancelableFetchUserProductItemRoles,
};
